export default __webpack_public_path__ + "media/images/images/elements/air-jordan-f6796ce297672c44ecd4c37df10d8cb9.png";